package com.mgacreative.hotel.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FloorFeature(
    val id: String? = null,
    @SerialName("tenant_id") val tenantId: String,
    @SerialName("floor_number") val floorNumber: Int,
    @SerialName("feature_type") val featureType: String, // "ELEVATOR" or "STAIRS"
    @SerialName("label") val label: String? = null,
    @SerialName("pos_x") val posX: Float = 50f,
    @SerialName("pos_y") val posY: Float = 50f,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null
)
